const config = {
    clientPortal: {
        logo: require("../../images/icons/connectMLS_background.png"),
        connectMLSTitle: "connectMLS"
    },
    publicPortal: {
        mainSection: {
            buttonText: "Sign in to work with your Realtor",
            buttonLink: "login",
            title: "Keep up to date with the latest",
            subtitle: "Get real-time updates, save favorite listings & search filters, get additional info, and add comments to listings"
        },
        footerSection: {
            texts: [
                "Properties for sale in San Diego area",
                "All information is provided exclusively for consumers’ personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties that a consumer may be interested in purchasing. All Information believed to be reliable but not guaranteed and should be independently verified.Buying or selling real estate? Find properties and real estate professionals in the San Diego area. You can search for listings, save listings to collections, share listings with others, connect with real estate professionals, and get property data and information. Sign up for free.",
                `Copyright © ${(new Date()).getFullYear()} bridgeMLS Powered by connectMLS`
            ],
            links: [
                {
                    text: "Terms of Use",
                    external: true,
                    url: `${process.env.REACT_APP_AgentURI}/termsofservice.jsp`
                },
                {
                    text: "Privacy Policy",
                    external: true,
                    url: "https://clienthelp.dynaconnections.net/privacy-policy/"
                },
                {
                    text: "DMCA Policy",
                    external: true,
                    url: "https://www.copyright.gov/legislation/dmca.pdf"
                }
            ]
        },
        mainSearchSection: {
            backgroundImage: require("../../images/public-portal/bg.webp"),
            title: "Find your home",
            subtitle: "in San Diego area",
            form: {
                inputSearchPlaceholder: "Enter a City or Zip Code",
                submitButton: "Search for Properties"
            },
        },
        navbar: {
            logo: require("../../images/icons/connectMLS_background.png"),
            href: "#",
            links: [
                {
                    text: "Buy",
                    external: false,
                    url: `search/public/Criteria={"propertyType":["House","Condo"],"status":"Active","forRent":false,"forSale":true}`
                },
                {
                    text: "Rent",
                    external: false,
                    url: `search/public/Criteria={"propertyType":["House","Condo"],"status":"Active","forRent":true,"forSale":false}`
                },
                {
                    text: "Sign In",
                    external: false,
                    url: "login",
                    modal: true
                }
            ]
        },
    }
}
export default config;